const KEY = "tb_pending_orders";

export function getPending() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function setPending(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
}

export function queuePendingOrder(payload) {
  const list = getPending();
  list.push({ id: Date.now(), payload });
  setPending(list);
}

export function pendingCount() {
  return getPending().length;
}
